import { useEffect, useState } from "react";
import { Users, Lock } from "lucide-react";
import { toast } from "sonner";
import { adsApiCall } from "./api";

/**
 * Small editor-header toggle that flips a project's team-sharing status.
 * Hidden entirely when the user isn't in a team yet.
 */
export default function TeamShareToggle({ projectId, initialShared }) {
  const [team, setTeam] = useState(null);
  const [shared, setShared] = useState(initialShared);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await adsApiCall.myTeam();
        if (r?.team) setTeam(r.team);
      } catch { /* anon / no team */ }
    })();
  }, []);

  useEffect(() => { setShared(initialShared); }, [initialShared]);

  if (!team || !projectId || projectId === "local") return null;

  async function toggle() {
    setBusy(true);
    try {
      const r = await adsApiCall.shareProjectWithTeam(projectId, !shared);
      setShared(!!r.shared);
      toast.success(r.shared
        ? `Shared with ${r.team_name || "team"}`
        : "Unshared — now private");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally { setBusy(false); }
  }

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={busy}
      data-testid="ads-editor-team-share"
      title={shared ? `Shared with ${team.name}` : "Share with your team"}
      className={`ads-btn ${shared ? "ads-btn-primary" : "ads-btn-ghost"}`}
      style={shared ? {
        background: "linear-gradient(135deg,#4ade80,#0ea5e9)",
      } : undefined}
    >
      {shared ? <Users size={16} /> : <Lock size={16} />}
      {shared ? `Shared` : `Private`}
    </button>
  );
}
